import NeoLoader from "@/components/loader";

export default {
    name: "analyzer-filters",
    components: {
        NeoLoader,
    },
    props: {
        analyzerOptions: {
            type: Object,
            default: {},
        }
    },

    data() {
        return {
        };
    },
    methods: {
        async handleAnalyseFilter() {
            this.$emit("startAnalyzer", this.analyzerFilterOptions);
            this.onCloseFilter();
        },
        beforeOpen() {
        },
        onCloseFilter() {
            this.$modal.hide("analyzer-filters");
        },
    },
    computed: {
        analyzerFilterOptions: {
            get() {
                return this.analyzerOptions;
            },
            set(val) {
                this.analyzerFilterOptions = val;
            },
        }
    },
};
